import { useEffect, useState } from 'react'
import { api } from '../lib/api'

const Projects = () => {
  const [projects, setProjects] = useState([])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const load = async () => {
      try {
        const data = await api.getProjects()
        setProjects(data)
      } catch (err) {
        setError(err.message || 'Failed to load projects')
      } finally {
        setLoading(false)
      }
    }

    load()
  }, [])

  return (
    <div className="space-y-8">
      <div className="flex flex-col gap-2">
        <div className="text-xs uppercase tracking-widest text-slate-500">Projects</div>
        <h1 className="text-3xl font-semibold">Your services</h1>
        <p className="text-slate-600">Create, manage, and monitor every app you ship with Flynt.</p>
      </div>

      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="rounded-full border border-slate-200 bg-white px-4 py-2 text-sm text-slate-500">
          Search by project name
        </div>
        <button className="rounded-full bg-slate-900 px-5 py-2 text-sm font-semibold text-white">
          New project
        </button>
      </div>

      {loading ? (
        <div className="rounded-3xl border border-slate-200 bg-white/85 p-6 text-sm text-slate-500">
          Loading projects...
        </div>
      ) : null}

      {error ? (
        <div className="rounded-3xl border border-rose-200 bg-rose-50 p-6 text-sm text-rose-600">
          {error}
        </div>
      ) : null}

      <div className="grid gap-6 md:grid-cols-2">
        {projects.map((project) => (
          <div key={project.id} className="rounded-3xl border border-slate-200 bg-white/85 p-6 shadow-sm">
            <div className="flex items-center justify-between">
              <div>
                <div className="text-lg font-semibold">{project.name}</div>
                <div className="text-xs text-slate-500">{project.runtime || 'Runtime'} � {project.region || 'Region'}</div>
              </div>
              <div className="rounded-full border border-slate-200 bg-slate-100 px-3 py-1 text-xs font-semibold text-ink">
                {project.serviceUrl ? 'Live' : 'New'}
              </div>
            </div>
            <div className="mt-4 grid grid-cols-2 gap-3 text-xs text-slate-500">
              <div>Region: {project.region || '--'}</div>
              <div>Deploys: --</div>
              <div>Latency: --</div>
              <div>Errors: --</div>
            </div>
            <div className="mt-6 flex gap-3">
              <button className="rounded-full border border-slate-300 px-4 py-2 text-xs font-semibold text-ink">
                View
              </button>
              <button className="rounded-full border border-slate-300 px-4 py-2 text-xs font-semibold text-ink">
                Deploy
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Projects
